import React from "react";
const AuthContext = React.createContext();
export default AuthContext;

/*import React from "react";

const initialState = {
  email: "",
  licenceemail: "",
  portionInfo: "",
  rsk: "",
  ask: "",
};

function reducer(state, action) {
  switch (action.type) {
    case "USER_INFO":
      return {
        ...state,
        email: action.useremail,
        licenceemail: action.licenceemail,
        portionInfo: action.portionInfo,
        rsk: action.rsk,
        ask: action.ask,
      };

    default:
      return state;
  }
}

export const AuthContext = React.createContext(initialState);

export function AuthCont(props) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {props.children}
    </AuthContext.Provider>
  );
}


*/
